import auth, { IResetPassword } from '../services/auth';
import resolveChallenge from './resolveChallenge';

export default async (formData: IResetPassword, onAfterReset?: () => void) => {
    const res = await auth.resetPassword(formData);
    if (onAfterReset) onAfterReset();
    resolveChallenge(res.data);
};
